/* eslint-disable import/prefer-default-export */

/**
 * Memulai countdown berdasarkan waktu delay yang diberikan.
 * Function ini akan otomatis membersihkan interval ketika countdown selesai.
 *
 * Fungsi ini akan memanggil `onTick` setiap detik dengan sisa waktu,
 * dan akan menjalankan `onAction` setelah countdown selesai.
 *
 * @param {number} delayInMs - Total waktu delay dalam milidetik.
 * @param {() => void} onAction - Fungsi yang akan dipanggil setelah countdown selesai.
 * @param {(secondsLeft: number) => void} onTick - Fungsi yang dipanggil setiap detik dengan sisa waktu dalam detik.
 * @returns {Object} Object yang berisi intervalId dan timeoutId untuk keperluan manual clearing.
 *
 * @example
 * // Penggunaan sederhana - SELF CLEARING
 * startCountdown(
 *   5000,
 *   () => console.log('Waktu habis!'),
 *   (sisa) => console.log(`Tersisa ${sisa} detik`)
 * );
 *
 * // Jika perlu manual clearing
 * const countdown = startCountdown(
 *   5000,
 *   () => console.log('Waktu habis!'),
 *   (sisa) => console.log(`Tersisa ${sisa} detik`)
 * );
 *
 * // Manual clearing (hanya jika diperlukan)
 * clearInterval(countdown.intervalId);
 * clearTimeout(countdown.timeoutId);
 */
export function startCountdown(delayInMs, onAction, onTick) {
  let secondsLeft = Math.ceil(delayInMs / 1000)

  const intervalId = setInterval(() => {
    secondsLeft -= 1
    if (secondsLeft > 0) {
      onTick(secondsLeft)
    } else {
      clearInterval(intervalId)
    }
  }, 1000)

  const timeoutId = setTimeout(() => {
    clearInterval(intervalId)
    onAction()
  }, delayInMs)

  return {
    intervalId,
    timeoutId,
  }
}
